var _defs, _circle, _circle2, _circle3, _circle4, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1165({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 7.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.69,
    y1: 10.47,
    x2: 7.14,
    y2: 8.48
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12.31,
    y1: 10.47,
    x2: 8.82,
    y2: 8.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1165);
export default __webpack_public_path__ + "static/media/Symbolpack_1_165.2d6dacb4feefa9ea694429ce39af26a5.svg";
export { ForwardRef as ReactComponent };